import { combineReducers } from 'redux';

import auth from './reducers/auth';
import appliances from './reducers/appliances';
import country from './reducers/country';
import newConfiguration from './reducers/newConfiguration';
import opportunity from './reducers/opportunity';
import configuration from './reducers/configuration';
import admin from './reducers/admin';
import applianceSerialNumber from './reducers/applianceSerialNumber';

export default combineReducers({
  auth,
  appliances,
  country,
  newConfiguration,
  opportunity,
  configuration,
  admin,
  applianceSerialNumber,
});
